let scrollLoad = true;
let nextPage = {
    article: 2,
    messages: 2
};

$(() => {
    $('#profileTabContent').on('scroll', (e) => {
        let div = $(e.currentTarget).get(0);
        let activeTab = $(div).find('.active')
        let activeId = activeTab.attr('id')

        if (div.scrollTop + div.clientHeight >= div.scrollHeight - 100) {
            if (scrollLoad) {
            $(activeTab).find('.show-more').removeClass('d-none')
                $.ajax({
                    url: `/api/${user_id}/get-${activeTab.attr('id')}?page=${nextPage[activeId]}`,
                    success: (res) => {
                        nextPage[activeId]++;
                        if (!res.includes('empty-content')) {
                            $('#' + activeTab.attr('id') + ' .items').append(res)
                        } else {
                            $(activeTab).find('.show-more').addClass('d-none')
                            if ($(activeTab).find('.empty-content').length === 0) {
                                $('#' + activeTab.attr('id') + ' .items').first().append(res)
                            }
                        }
                    },
                    complete: () => {
                        scrollLoad = $(activeTab).find('.empty-content').length === 0;
                    },
                    error: (err) => {
                        scrollLoad = true
                        console.log(err)
                    },
                })
            }
            scrollLoad = false
        } else {
            if (scrollLoad === false) {
                $(activeTab).find('.show-more').addClass('d-none')
            }
        }
    })

    $('#findConnectedUser input').on('keyup', (e) => {
        getConnectedUser(
            $('#followModal .modal-header .nav-link.active').data('type'),
            $(e.currentTarget).val()
        )
    })

    // if open-tab is set in url, open the tab
    let url = new URL(window.location.href);
    let openTab = url.searchParams.get("open-tab");
    if (openTab) {
        $(`#${openTab}-tab`).click();
    }
})
$(document).on("click","#navModal",(e) => {
    e.stopPropagation();
    let toast = $(".toast");
    let thisBtn = $(e.currentTarget);

    if (thisBtn.hasClass("show")) {
        $(".profile-nav-btn .open_btn").removeClass("rotate-180");
        $(".toast.profile-nav-modal").attr("style","z-index:0");

        thisBtn.removeClass("show");
        toast.toast("hide");

    } else {
        $(".profile-nav-btn .open_btn").addClass("rotate-180");
        $(".toast.profile-nav-modal").attr("style","z-index:2");

        thisBtn.addClass("show");
        toast.toast({
            autohide : false
        }).toast('show');
    }
});

// Event for hide modal when click outside of modal.
$(document).on("click",function(e) {
    if (!$(e.target).is(".toast.profile-nav-modal") && $("#navModal").hasClass("show")) {
        $("#navModal").removeClass("show");
        $(".toast.profile-nav-modal").toast("hide").attr("style","z-index:0");
        $(".profile-nav-btn .open_btn").addClass("rotate-180");

    }
});

$(document).on("click",".nav-link", (e) => {

    $(".nav-link span.checked").addClass('d-none');
    $(".nav-link span.default").removeClass('d-none');
    $(e.currentTarget.children[0]).removeClass('d-none');
    $(e.currentTarget.children[1]).addClass('d-none');

    $(".profile-nav-header").html(e.currentTarget.outerText);

});


const getConnectedUser = (type, search) => {
    $.ajax({
        url: `api/connected-user/${user_id}/${type}`,
        data: {
            search: search
        },
        success: (res) => {
            $(`.${type}-area .item`).remove();
            res.map((value, key) => {
                console.log(value, key)
                $(`.${type}-area`).append(`
                    <div class="item col-4 mb-3">
                        <img src="${value.profile_image}" alt="${value.name}'s avatar">
                        <a href="${value.url}">${value.name}</a>
                    </div>
                `)
            })
        }
    })
}


//Event for enter message detail link of profile.
$(document).on("click", ".message-detail", function (e) {
    e.preventDefault();
    var $this = $(this);
    var $thread_id = $this.attr('data-thread_id');
    $.ajax({
        data: {
            thread_id : $thread_id,
        },
        method: 'post',
        url: '/profil/get-msg-detail-ajax'
    }).then(function (response) {
        $('.profile-msg-show').html(response).attr('style','display:block;');
        $('.profile-msg-list,.js-profile-create-msg').attr('style','display:none !important;');
    })
});

//Event for new message button of profile.
$(document).on('click', '.js-profile-create-msg', function (e) {
    e.preventDefault();
    $('.profile-msg-create').attr('style', 'display:block;');
    $('.profile-msg-list').attr('style', 'display:none;');
    $('.js-profile-create-msg').attr('style', 'display:none !important;');
    $('.empty-messages').attr('style','display:none');
});

//Event for back to messages button of profile.
$(document).on('click', '.js-back-to-msg', function (e) {
    e.preventDefault();
    $('.profile-msg-create').attr('style', 'display:none;');
    $('.profile-msg-list').attr('style', 'display:block;');
    $('.js-profile-create-msg').attr('style', 'display:block;');
    $('.empty-messages').attr('style','display:block');
});

//Event for reply button of profile message detail.
$(document).on('click', '.js-open-detail-reply', function (e) {
    e.preventDefault();
    $('.js-open-detail-reply').attr('style', 'display:none;');
    $('.profile-msg-detail-reply-form').attr('style', 'display:block;');
});

//Event for back to messages from message detail of profile.
$(document).on('click', '.js-back-from-msg-detail', function (e) {
    e.preventDefault();
    $('.profile-msg-show').attr('style', 'display:none;');
    $('.profile-msg-list').attr('style', 'display:block;');
    $('.js-profile-create-msg').attr('style', 'display:block;');
});

//Event for reply form of message detail inside profile.
$(document).on('submit', '.profile-msg-detail-reply-form', function (e) {
    e.preventDefault();
    var $thread_id = $('#detail-thread_id').val();
    var $message = $('#detail-message').val();
    var _token = $('#_token').val();
    $.ajax({
        data: {
            thread_id : $thread_id,
            message : $message,
            _token : _token,
        },
        method: 'post',
        url: '/profil/post-msg-detail-ajax'
    }).then(function (response) {
        $('.profile-msg-show').html(response).attr('style','display:block;');
        $('.profile-msg-list').attr('style','display:none;');
        $('.js-profile-create-msg').attr('style', 'display:none !important;');
    })
});

//Event for deleting conversation (just admin can see.).
$(document).on('submit', '#js-profile-detail-delete-message', function (e) {
    e.preventDefault();
    var $thread_id = $('#detail-delete-thread_id').val();
    var _token = $('#_token').val();
    $.ajax({
        data: {
            thread_id : $thread_id,
            _token : _token,
        },
        method: 'post',
        url: '/profil/delete-msg-detail-ajax'
    }).then(function (response) {
        if (response.status == 'success') {
            $('.profile-msg-show').attr('style','display:none;');
            $('.profile-msg-list').attr('style','display:block;');
            $('.js-profile-create-msg').attr('style', 'display:block ;');
        }
    })
});

//Event for report medal button of message boxes inside profile.
$(document).on('submit', '#js-report-medal', function (e) {
    e.preventDefault();
    var $message_id = $('#report-medal-message_id-'+$(this).attr('data-message-id')).val();
    var report_token = $('#report_token').val();

    $.ajax({
        data: {
            message_id : $message_id,
            report_token : report_token
        },
        method: 'post',
        url: '/profil/medal-msg-detail-ajax'
    }).then(function (response) {
        if (response.status == 'success') {
            $('.profile-msg-show').attr('style','display:none;');
            $('.profile-msg-list').attr('style','display:block;');
            $('.js-profile-create-msg').attr('style', 'display:block;');
        }
    })
});

//Event for single delete procces of messages inside profile.
$(document).on('submit', '#js-delete-msg-single', function (e) {
    e.preventDefault();
    var $message_id = $('#single-message_id-'+$(this).attr('data-single-message-id')).val();
    var _token = $('#single-delete-token').val();
    $.ajax({
        data: {
            message_id : $message_id,
            _token : _token,
        },
        method: 'post',
        url: '/profil/delete-msg-detail-ajax'
    }).then(function (response) {
        if (response.status == 'success') {
            $('.profile-msg-show').attr('style','display:none;');
            $('.profile-msg-list').attr('style','display:block;');
            $('.js-profile-create-msg').attr('style', 'display:block ;');
        }
    })
});